import React from 'react';
import {Chip} from '@mui/material';

const statusColorMap = {
    Confirmed: 'success',
    Frozen: 'info',
    Reversed: 'error',
    'In review': 'warning',
    'Awaiting payment': 'warning',
    'Awaiting transfer': 'warning',
    Expired: 'default',
    Active: 'success',
    Inactive: 'default',
    unclaimed: 'error',
    claimed: 'success',
    flag: 'error',
};

/**
 * Status / flag chip for BizPoint lists.
 * Pass `flag` for red “no contact set” / unclaimed-style indicators.
 */
const StatusPill = ({status, label, flag = false}) => {
    const resolvedStatus = flag ? 'flag' : status;
    const color = statusColorMap[resolvedStatus] ?? 'default';
    return (
        <Chip
            size="small"
            label={label ?? status}
            color={color}
            variant={color === 'default' ? 'outlined' : 'filled'}
        />
    );
};

export default StatusPill;
